import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useQuery } from 'react-query'
import CheckCircleIcon from '@offerzen/zenicon/CheckCircleIcon'

import { format } from 'date-fns/format'
import { Container, parseURLParams, Notification } from '@offerzen/pinata-shame'
import { restClient } from 'config/restClient'

import SendTerms from '../../components/SendTerms'
import ErrorScene from '../ErrorScene'
import ContentWithTOC from '../../components/ContentWithTOC'
import EmployerTermsAndConditions from '../../components/EmployerTermsAndConditions'
import TermsOfService from '../../components/EmployerTermsAndConditions/TermsOfService'
import Introduction from '../../components/EmployerTermsAndConditions/Introduction'
import AboutTerms from '../../components/EmployerTermsAndConditions/AboutTerms'
import SignTermsFooter from '../../components/EmployerTermsAndConditions/SignTermsFooter'

import styles from './styles'

const getCompanyTerms = async token => {
  const tokenParam = token ? `?token=${token}` : ''
  const response = await restClient(`/api/company/v2/terms${tokenParam}`, {
    method: 'GET',
  })

  return response.data
}

const EmployerSignTerms = ({ location }) => {
  const { token, show_send_terms: showSendTermsParam } = parseURLParams(location.search)
  const [hasSignedTerms, setHasSignedTerms] = useState()

  const { data: companyTerms, isLoading, isError, error } = useQuery(
    ['companyTerms'],
    () => getCompanyTerms(token),
    {
      refetchOnWindowFocus: false,
    },
  )

  const isAuthorised = !isLoading && !(error?.request.status === 401)

  if (isError && error?.request.status !== 401) {
    return <ErrorScene />
  }

  const acceptDate = companyTerms?.result.accepted_terms_on && format(companyTerms?.result.accepted_terms_on, 'd MMMM yyyy')

  return (
    <>
      <If condition={isLoading}>
        <p className={styles.accessiblyHidden}>Loading</p>
      </If>

      <If condition={isAuthorised && companyTerms?.result.has_signed_terms}>
        <Notification theme="success" icon={CheckCircleIcon} className={styles.notification}>
          <p role="status">{`${companyTerms?.result.company_name} accepted our terms on ${acceptDate}.`}</p>
        </Notification>
      </If>

      <Container>
        <ContentWithTOC className={companyTerms?.result.has_signed_terms && styles.content}>
          <EmployerTermsAndConditions>
            <Introduction />

            <If condition={isAuthorised && !companyTerms.result.has_signed_terms && !hasSignedTerms}>
              <Notification theme="secondary" className={styles.sendTermsBanner}>
                <SendTerms
                  token={token}
                  companyId={companyTerms.result.company_profile_id}
                  buttonTheme="secondary"
                  isModalVisibleInitialState={showSendTermsParam !== undefined}
                />
              </Notification>
            </If>

            <AboutTerms />
            <TermsOfService />

            <If condition={isAuthorised}>
              <SignTermsFooter
                token={token}
                companyId={companyTerms.result.company_profile_id}
                hasSignedTerms={companyTerms.result.has_signed_terms}
                setHasSignedTerms={setHasSignedTerms}
              />
            </If>
          </EmployerTermsAndConditions>
        </ContentWithTOC>
      </Container>
    </>
  )
}

EmployerSignTerms.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
}

export default EmployerSignTerms
